import { FC } from 'react';
import { toLocalePhoneNumber, useTranslation } from '@chr/online-shared-ui-localizations';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';

export declare interface ContactUsProps {
  bookingNumber: number;
  email?: string;
  phone?: string;
}

export const ContactUs: FC<ContactUsProps> = ({ bookingNumber, email, phone }) => {
  const translate = useTranslation();
  const theme = useTheme();

  if (!email && !phone) {
    return null;
  }

  const emailSubject = encodeURIComponent(
    translate('Inquiry on Booking {0}', [bookingNumber ?? '']),
  );

  return (
    <Stack spacing={2}>
      <Divider sx={{ borderColor: theme.palette.divider }} />
      <Typography variant="h3" marginBottom={2}>
        {translate('Contact Us')}
      </Typography>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="flex-start"
        spacing={{ xs: 2, sm: 8 }}
        flexWrap={'wrap'}
      >
        {email && (
          <Box sx={{ wordBreak: 'break-all' }}>
            <Typography variant="body1" gutterBottom>
              {translate('Email')}
            </Typography>
            <Typography variant="subtitle2">
              <div className="fs-mask">
                <a href={`mailto:${email}?subject=${emailSubject}`}>{email}</a>
              </div>
            </Typography>
          </Box>
        )}
        {phone && (
          <Box>
            <Typography variant="body1" gutterBottom>
              {translate('Phone')}
            </Typography>
            <Typography variant="subtitle2">
              <div className="fs-mask">
                {toLocalePhoneNumber(phone)}
              </div>
            </Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
